import jQuery from 'jquery';

import { restoreAnimationDataAttributes } from '../restore-animation-data-attributes';

const isValidAnimationTarget = ($element: JQuery): boolean => {
  if ('function' === typeof window.et_has_animation_data && window.et_has_animation_data($element)) {
    return true;
  }

  // Fallback for legacy flows where animation classes can still mark a valid target.
  return $element.hasClass('et_animated') || $element.hasClass('et_had_animation');
};

/**
 * Find all elements with animation data, including nested elements.
 *
 * @param {JQuery} $container The container element to search within.
 * @returns {JQuery} JQuery collection of elements with animation data.
 */
export const findElementsWithAnimations = ($container: JQuery): JQuery => {
  const elementsSet = new Set<HTMLElement>();

  // Find all elements with data-animation-style attribute (including container)
  $container
    .find('[data-animation-style]')
    .addBack('[data-animation-style]')
    .each((index, elem) => {
      const $elem = jQuery(elem);

      if (!isValidAnimationTarget($elem)) {
        return;
      }

      elementsSet.add(elem);
    });

  // Also check for elements with animation classes (via hasAnimationData)
  if ('function' === typeof window.et_has_animation_data) {
    $container
      .find('*')
      .addBack()
      .each((index, elem) => {
        // Skip if already added
        if (elementsSet.has(elem)) {
          return;
        }

        const $elem = jQuery(elem);
        if (window.et_has_animation_data($elem)) {
          elementsSet.add(elem);

          // Restore animation data attributes if missing
          if (!$elem.attr('data-animation-style')) {
            restoreAnimationDataAttributes($elem);
          }
        }
      });
  }

  // Convert Set to jQuery collection
  return jQuery(Array.from(elementsSet));
};
